// Textele de ajutor din interfata R.E.S.D.P.S. (tooltip-uri si panoul "Ajutor"), fara importuri, ca sa poata fi
// testate cu node. Regulile descrise sunt cele din Ordinul MDLPA 407/2026 si din API; la o schimbare de regula
// se actualizeaza si textul de aici.

// Un tooltip lung incarca ecranul; textele mai lungi merg doar in panou.
export const HELP_TEXT_MAX_LENGTH = 300;

export const CONCEPT_HELP = Object.freeze({
  file: {
    title: "Dosar succesoral",
    text:
      "Evidenta primariei pentru succesiunea unei persoane decedate. Pastreaza datele sesizarii pentru deschiderea " +
      "procedurii succesorale (S.D.P.S.) si urmareste verificarea bunurilor si a debitelor, pana la transmiterea " +
      "catre Camera notarilor sau pana la clasare.",
  },
  draft: {
    title: "Ciorna",
    text:
      "Dosar salvat, dar inca neinregistrat. Nu are numar in R.E.S.D.P.S. si nu apare in registru. Se poate " +
      "completa, modifica sau sterge oricand.",
  },
  register: {
    title: "Registrul R.E.S.D.P.S.",
    text:
      "Registrul electronic al sesizarilor, tinut pe ani calendaristici. Numerele au 5 cifre si incep de la 00001 " +
      "in fiecare an, in ordinea inregistrarii. Numarul primit de un dosar nu se mai atribuie altui dosar; si " +
      "dosarele anulate raman in registru, cu numarul lor.",
  },
  generalRegistry: {
    title: "Registratura generala",
    text:
      "Registrul general de intrari-iesiri al primariei. Sesizarea se inregistreaza si acolo, iar numarul si data " +
      "din registratura generala apar in antetul ei.",
  },
  requiredMarks: {
    title: "Campuri marcate",
    text:
      "* inseamna obligatoriu pentru salvarea ciornei. ● inseamna necesar pentru inregistrarea in R.E.S.D.P.S. " +
      "Ciorna se poate salva si fara campurile ●.",
  },
  transmissionDeadline: {
    title: "Termen transmitere",
    text:
      "Sesizarea se transmite Camerei notarilor in 30 de zile calendaristice: de la data decesului (din oficiu) " +
      "sau de la primirea cererii C.D.P.S. Termenul nu se mai urmareste dupa verdictul fara bunuri si fara " +
      "debite si nici in starile finale.",
  },
  classification: {
    title: "Clasare",
    text:
      "Daca defunctul nu are bunuri si nici debite la bugetul local, sesizarea nu se transmite Camerei, iar " +
      "dosarul se claseaza la 6 luni de la data decesului (Anexa 1 pct. 4). La Observatii se adauga mentiunea legala.",
  },
  rectification: {
    title: "Rectificari",
    text:
      "Dupa inregistrare datele nu se mai editeaza direct, ci se rectifica, cu motiv. Pentru fiecare camp corectat " +
      "raman valoarea veche, valoarea noua, motivul, data si utilizatorul.",
  },
  history: {
    title: "Istoric",
    text:
      "Jurnalul operatiilor asupra dosarului: creare, modificari, inregistrare, verdict, clasare, transmitere, " +
      "anulare si consultari. Arata cine, cand si ce s-a schimbat.",
  },
  documents: {
    title: "Documente emise",
    text:
      "Documentele generate din dosar raman la dosar. Se pastreaza toate generarile, fiecare cu data, " +
      "utilizatorul si versiunea sablonului folosit. Verifica arata daca fisierul si sablonul din care a iesit " +
      "au ramas neschimbate.",
  },
});

// Drumul dosarului, in ordine, pentru panoul "Ajutor".
export const FLOW_HELP = Object.freeze([
  "Ciorna: se completeaza datele; se poate salva si incompleta.",
  "Inregistrat: dosarul primeste numar in R.E.S.D.P.S. si se verifica bunurile si debitele defunctului.",
  "Cu bunuri sau debite: Sesizare de transmis, apoi Transmis, dupa ce Camera notarilor inregistreaza sesizarea.",
  "Fara bunuri si fara debite: dosarul ramane Inregistrat si devine Clasat la 6 luni de la deces.",
  "Anulat: un dosar Inregistrat sau Sesizare de transmis se poate anula, cu motiv; numarul ramane ocupat.",
]);

export const STATUS_HELP = Object.freeze({
  Draft:
    "Dosar inceput, fara numar in registru. Se poate completa, modifica sau sterge oricand. Pentru inregistrare " +
    "trebuie completate campurile marcate ●.",
  Registered:
    "Dosarul are numar in R.E.S.D.P.S. Urmeaza verificarea bunurilor si a debitelor si consemnarea verdictului: " +
    "cu bunuri sau debite sesizarea se transmite Camerei notarilor, fara ele dosarul se claseaza la 6 luni de la deces.",
  ToTransmit:
    "S-au gasit bunuri sau debite. Sesizarea se transmite Camerei notarilor in termenul de 30 de zile, apoi se " +
    "consemneaza numarul si data primite de la Camera.",
  Transmitted:
    "Sesizarea a fost inregistrata la Camera notarilor, iar obligatia primariei este indeplinita (Anexa 2 pct. 11). " +
    "Stare finala: se mai pot face doar rectificari.",
  Classified:
    "Defunctul nu are bunuri si nici debite la bugetul local, asa ca sesizarea nu s-a transmis Camerei. Dosarul " +
    "a fost clasat, cu mentiunea de la Observatii. Stare finala: se mai pot face doar rectificari.",
  Cancelled:
    "Dosarul a fost anulat, cu motiv. Numarul ramane ocupat, iar pozitia ramane in registru cu mentiunea Anulat. " +
    "Stare finala: nu se mai pot face operatii.",
});

// Cheile sunt actiunile din matricea API (allowedActions din helpers/resdps.js).
export const ACTION_HELP = Object.freeze({
  EditDraft:
    "Modifica datele ciornei. Ciorna se poate salva si incompleta; minimul este tipul sesizarii, numele, " +
    "prenumele si data decesului.",
  DeleteDraft:
    "Sterge definitiv ciorna. Ciorna nu are numar in registru, deci nu ramane nicio pozitie ocupata.",
  Register:
    "Da dosarului urmatorul numar din R.E.S.D.P.S. Dupa inregistrare datele se schimba doar prin rectificare, " +
    "cu motiv, iar dosarul nu se mai poate sterge, doar anula.",
  RecordAssetsVerdict:
    "Consemneaza rezultatul verificarii. Cu bunuri sau debite, dosarul trece in Sesizare de transmis. Fara bunuri " +
    "si fara debite, ramane Inregistrat si poate fi clasat la 6 luni de la deces. Verdictul se poate schimba.",
  Classify:
    "Inchide dosarul fara bunuri si fara debite. Este posibila dupa verdictul fara bunuri si fara debite, la cel " +
    "putin 6 luni de la deces. La Observatii se adauga mentiunea legala.",
  RecordChamberRegistration:
    "Consemneaza Camera notarilor, numarul si data la care Camera a inregistrat sesizarea. Dosarul devine Transmis.",
  GenerateSdps:
    "Genereaza sesizarea catre Camera notarilor din datele dosarului, cu Camera aleasa. Documentul ramane la dosar, " +
    "in tab-ul Documente. Se poate genera din nou dupa o rectificare; se pastreaza toate generarile facute.",
  Rectify:
    "Corecteaza datele unui dosar inregistrat. Motivul este obligatoriu; valoarea veche si cea noua raman in " +
    "tab-ul Rectificari.",
  Cancel:
    "Anuleaza un dosar inregistrat, cu motiv obligatoriu. Numarul din registru ramane ocupat, iar dosarul nu se " +
    "mai poate modifica.",
});

// Explicatii legate de un ecran anume, care nu au loc in panoul "Ajutor".
export const SCREEN_HELP = Object.freeze({
  statusFilter:
    "In lucru inseamna Ciorna, Inregistrat si Sesizare de transmis. Transmis, Clasat si Anulat sunt stari finale. " +
    "Butonul Ajutor explica fiecare stare.",
  downloadCdps:
    "Formularul tipizat necompletat. Il completeaza solicitantul si il depune la secretarul general, " +
    "care il foloseste pentru cererea de deschidere a procedurii succesorale.",
});

// Doar campurile al caror rost nu reiese din eticheta; cheile sunt numele din FIELD_LABELS.
export const FIELD_HELP = Object.freeze({
  origin:
    "Din oficiu: primaria intocmeste sesizarea dupa ce afla de deces; termenul de 30 de zile curge de la data " +
    "decesului. Cerere C.D.P.S.: sesizarea se intocmeste la cererea primita; termenul curge de la data primirii ei.",
  cdpsReceivedDate:
    "Data la care primaria a primit cererea C.D.P.S. De la ea curge termenul de 30 de zile. E necesara la " +
    "inregistrare doar pentru cererile C.D.P.S.",
  cnp: "Se verifica cifra de control si data nasterii. Nu se pot inregistra doua dosare pentru acelasi CNP.",
  cnpMissingReason:
    "Se completeaza doar cand CNP-ul nu se cunoaste. Pentru inregistrare e nevoie de CNP sau de motivul lipsei lui.",
  registryEntryId:
    "Sesizarea se inregistreaza si in registratura generala. Cautati intrarea dupa numar; numarul si data ei " +
    "apar in antetul sesizarii.",
  observations:
    "La clasare se adauga aici automat mentiunea legala. Se pot trece si alte precizari despre dosar.",
  notaryChamberId:
    "Camera notarilor publici careia i s-a transmis sesizarea si care a inregistrat-o.",
  reason:
    "Explicati ce se corecteaza si pe baza carui document. Motivul ramane in tab-ul Rectificari si in istoric.",
});

const textFrom = (map, key) =>
  Object.prototype.hasOwnProperty.call(map, key) ? map[key] : "";

export const statusHelp = (status) => textFrom(STATUS_HELP, status);
export const actionHelp = (action) => textFrom(ACTION_HELP, action);
export const fieldHelp = (field) => textFrom(FIELD_HELP, field);
